export default __webpack_public_path__ + "017670087a0c48bec82e01fb261528c1.png";